import React, { Component } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'

import Input from '../../common/Input'
import RadioButton from '../../common/RadioButton'

import * as Constants from '../../../helpers/Constants'
import * as Strings from './strings'

class InformationModal extends Component {
  render() {
    const {
      show = true,
      hide,
      titleInput,
      onChangeTitle,
      errorTitle,
      titleEnglishInput,
      onChangeTitleEnglish,
      informationInput,
      onChangeInformation,
      errorInformation,
      informationEnglishInput,
      onChangeInformationEnglish,
      classes,
      header,
      information,
      onDone,
      loading = false,
      errorMessage = '',
      type,
      onChangeType
    } = this.props

    return (
      <Dialog open={show} aria-labelledby={'form-dialog-title'}>
        <DialogTitle id={'form-dialog-title'}>{header}</DialogTitle>
        <DialogContent>
          <DialogContentText>{information}</DialogContentText>
          {errorMessage === '' ? null : (
            <p style={{ fontSize: 12, color: '#e57373' }}>{errorMessage}</p>
          )}
          <RadioButton
            placeholder={Strings.default.PHONE_NUMBER}
            checked={type === Constants.PHONE}
            style={{ marginTop: 15 }}
            onChange={() => onChangeType(Constants.PHONE)}
          />
          <RadioButton
            placeholder={Strings.default.EMAIL}
            checked={type === Constants.EMAIL}
            style={{ marginTop: 15 }}
            onChange={() => onChangeType(Constants.EMAIL)}
          />
          <RadioButton
            placeholder={Strings.default.URL}
            checked={type === Constants.URL}
            style={{ marginTop: 15 }}
            onChange={() => onChangeType(Constants.URL)}
          />
          <RadioButton
            placeholder={Strings.default.PLAIN_TEXT}
            checked={type === Constants.TEXT}
            style={{ marginTop: 15 }}
            onChange={() => onChangeType(Constants.TEXT)}
          />
          <Input
            placeholder={Strings.default.TITLE + '*'}
            value={titleInput}
            onChange={text => onChangeTitle(text)}
            error={errorTitle}
          />
          <Input
            placeholder={Strings.default.TITLE_ENGLISH}
            value={titleEnglishInput}
            onChange={text => onChangeTitleEnglish(text)}
          />
          <Input
            placeholder={Strings.default.INFORMATION[type] + '*'}
            value={informationInput}
            onChange={text => onChangeInformation(text)}
            error={errorInformation}
          />
          {type === Constants.TEXT ? (
            <Input
              placeholder={Strings.default.INFORMATION_ENGLISH}
              value={informationEnglishInput}
              onChange={text => onChangeInformationEnglish(text)}
            />
          ) : null}
        </DialogContent>
        {loading ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 15
            }}
          >
            <CircularProgress
              style={{ color: '#289e64' }}
              thickness={6}
              size={20}
            />
          </div>
        ) : (
          <DialogActions>
            <Button
              onClick={() => hide()}
              classes={{ label: classes.warningButtonText }}
            >
              {Strings.default.CANCEL}
            </Button>
            <Button
              onClick={() => onDone()}
              classes={{ label: classes.successButtonText }}
            >
              {Strings.default.DONE}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    )
  }
}

const Styles = {
  successButtonText: {
    color: '#289e64'
  },
  warningButtonText: {
    color: '#e57373'
  }
}

export default withStyles(Styles)(InformationModal)



// WEBPACK FOOTER //
// ./src/components/common/InformationModal/index.js